// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos gerais */
.search-component {
    width: 100%;
    height: 40vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    font-family: Arial, sans-serif;
    gap: 10px;
}
.modal-header-title{
    display:flex;
    justify-content: flex-start;
    flex-direction: column;
}
.modal-overlay-prof{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1060;
}

/* Campo de busca */
.search-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 16px;
    transition: border 0.3s ease-in-out;
}

.search-input:focus {
    border-color: #3e9af0;
    outline: none;
}

/* Lista de resultados */
.search-results {
    overflow-y: auto;
    max-height: 50vh; /* Ajusta para caber melhor em telas menores */
    padding: 0;
    margin: 0;
    list-style: none;
    border-radius: 8px;
    background: #fff;
}

.search-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 10px;
    padding: 25px;
    border-radius: 10px;
    border: 1px solid #dbdbdb;
    transition: background 0.3s ease-in-out;
}

.search-item:last-child {
    border-bottom: none;
}
.close-button-prof{
    padding: 10px 12px;
    border-radius: 15px;
    background-color: rgb(248, 6, 6);
    color: white;
    cursor: pointer;
}
.modal-header-prof{
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
}
.new {
    background-color: #e6f7e6;
    border-left: 4px solid #00a5a5;
}
.temp-removed{
    background-color: #ffa5a55e;
    border-left: 4px solid #f10639;
}
.added {
    background-color: #e6f7f3;
    border-left: 4px solid #28a796;
}

.removed {
    background-color: #ffffff;
    border-left: 4px solid #a1a1a1;
}
/* Layout da linha de cada item */
.search-item-component {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-grow: 1;
}

.modal-msg-prof{
    display: none;
    padding-top: 10px;
    padding-left: 10px;
    color: #a1a1a1;
    font-size: 14px;
}

.search-item h2 {
    font-size: 16px;
    margin: 0;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Estilização dos botões */
.btn-confirm, .btn-remove-prof, .btn-add, .btn-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    transition: transform 0.2s, background 0.3s;
}
.btn-footer-container{
    display:flex;
    margin: 10px;
    justify-content: right;
}

.btn-confirm {
    background-color: #3e9af0;
    color: white;
    border: 1px solid #3e9af0;
    width: 400px;
}

.btn-confirm:hover {
    background-color: white;
    color: #3e9af0;
    border: 1px solid #3e9af0;
}

.btn-remove-prof {
    background: none;
    border: none;
    padding: 4px;
    transition: transform 0.3s ease;
}

.btn-remove-prof:hover {
    transform: scale(1.1);
}

/* Checkbox estilizado */
.checkbox-container {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.checkbox-container input {
    display: none;
}

.custom-checkbox {
    width: 18px;
    height: 18px;
    border-radius: 4px;
    background-color: white;
    border: 2px solid #ccc;
    display: inline-block;
    transition: background 0.3s, border 0.3s;
}
.checkbox-container input:checked + span.teste {
    border-color: #28a7463f;
}
.checkbox-container input:checked + .custom-checkbox {
    background-color: #28a745;
    border-color: #28a745;
}


/* Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.my-modal-content-prof {
    width: 90%;
    max-width: 1100px;
    min-width: 300px;
    background: white;
    padding: 20px;
    border-radius: 8px;
    min-width: 1100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 60vh;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 80px;
    margin-top: 60px;
    margin-right: 30px;
    margin-left: 30px;
}


.my-modal-content-prof h3 {
    font-size: 15px;
    font-weight:normal;
    margin-bottom: 0;
}

/* Botão de fechar */
.my-modal-content > button {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 15px;
    color: #555;
}

.my-modal-content > button:hover {
    color: #000;
}

/* Responsividade */
@media (max-width: 1100px) {
    .my-modal-content-prof {
        min-width: 800px;
    }
    .search-results {
        max-height: 40vh; /* Ajusta para caber melhor em telas menores */
    }
    
}

@media (max-width: 1024px) {
    .my-modal-content-prof {
        min-width: 600px;
    }
}

@media (max-width: 768px) {
    .my-modal-content-prof {
        min-width: 400px;
    }
}
@media (max-width: 600px) {
    .my-modal-content-prof {
        min-width: 300px;
    }
}

@media (max-height: 667px) {
    .my-modal-content-prof {
        margin: 50px;
    }
}
@media (max-height: 540px) {
    .my-modal-content-prof {
        max-height: 430px;
        margin: 50px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/ProfessionalsModal.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,gBAAgB,EAAE,8CAA8C;IAChE,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;AACA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;AACA,iCAAiC;AACjC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,wCAAwC;AAC5C;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA,UAAU;AACV;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,mBAAmB;AACnB;IACI;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB,EAAE,8CAA8C;IACpE;;AAEJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,YAAY;IAChB;AACJ","sourcesContent":["/* Estilos gerais */\n.search-component {\n    width: 100%;\n    height: 40vh;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    font-family: Arial, sans-serif;\n    gap: 10px;\n}\n.modal-header-title{\n    display:flex;\n    justify-content: flex-start;\n    flex-direction: column;\n}\n.modal-overlay-prof{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1060;\n}\n\n/* Campo de busca */\n.search-input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-size: 16px;\n    transition: border 0.3s ease-in-out;\n}\n\n.search-input:focus {\n    border-color: #3e9af0;\n    outline: none;\n}\n\n/* Lista de resultados */\n.search-results {\n    overflow-y: auto;\n    max-height: 50vh; /* Ajusta para caber melhor em telas menores */\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    border-radius: 8px;\n    background: #fff;\n}\n\n.search-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px 10px;\n    padding: 25px;\n    border-radius: 10px;\n    border: 1px solid #dbdbdb;\n    transition: background 0.3s ease-in-out;\n}\n\n.search-item:last-child {\n    border-bottom: none;\n}\n.close-button-prof{\n    padding: 10px 12px;\n    border-radius: 15px;\n    background-color: rgb(248, 6, 6);\n    color: white;\n    cursor: pointer;\n}\n.modal-header-prof{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n}\n.new {\n    background-color: #e6f7e6;\n    border-left: 4px solid #00a5a5;\n}\n.temp-removed{\n    background-color: #ffa5a55e;\n    border-left: 4px solid #f10639;\n}\n.added {\n    background-color: #e6f7f3;\n    border-left: 4px solid #28a796;\n}\n\n.removed {\n    background-color: #ffffff;\n    border-left: 4px solid #a1a1a1;\n}\n/* Layout da linha de cada item */\n.search-item-component {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    flex-grow: 1;\n}\n\n.modal-msg-prof{\n    display: none;\n    padding-top: 10px;\n    padding-left: 10px;\n    color: #a1a1a1;\n    font-size: 14px;\n}\n\n.search-item h2 {\n    font-size: 16px;\n    margin: 0;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Estilização dos botões */\n.btn-confirm, .btn-remove-prof, .btn-add, .btn-remove {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 16px;\n    border-radius: 20px;\n    font-size: 14px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: transform 0.2s, background 0.3s;\n}\n.btn-footer-container{\n    display:flex;\n    margin: 10px;\n    justify-content: right;\n}\n\n.btn-confirm {\n    background-color: #3e9af0;\n    color: white;\n    border: 1px solid #3e9af0;\n    width: 400px;\n}\n\n.btn-confirm:hover {\n    background-color: white;\n    color: #3e9af0;\n    border: 1px solid #3e9af0;\n}\n\n.btn-remove-prof {\n    background: none;\n    border: none;\n    padding: 4px;\n    transition: transform 0.3s ease;\n}\n\n.btn-remove-prof:hover {\n    transform: scale(1.1);\n}\n\n/* Checkbox estilizado */\n.checkbox-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.checkbox-container input {\n    display: none;\n}\n\n.custom-checkbox {\n    width: 18px;\n    height: 18px;\n    border-radius: 4px;\n    background-color: white;\n    border: 2px solid #ccc;\n    display: inline-block;\n    transition: background 0.3s, border 0.3s;\n}\n.checkbox-container input:checked + span.teste {\n    border-color: #28a7463f;\n}\n.checkbox-container input:checked + .custom-checkbox {\n    background-color: #28a745;\n    border-color: #28a745;\n}\n\n\n/* Modal */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.my-modal-content-prof {\n    width: 90%;\n    max-width: 1100px;\n    min-width: 300px;\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    min-width: 1100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: 60vh;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    margin-bottom: 80px;\n    margin-top: 60px;\n    margin-right: 30px;\n    margin-left: 30px;\n}\n\n\n.my-modal-content-prof h3 {\n    font-size: 15px;\n    font-weight:normal;\n    margin-bottom: 0;\n}\n\n/* Botão de fechar */\n.my-modal-content > button {\n    background: none;\n    border: none;\n    font-size: 18px;\n    cursor: pointer;\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    color: #555;\n}\n\n.my-modal-content > button:hover {\n    color: #000;\n}\n\n/* Responsividade */\n@media (max-width: 1100px) {\n    .my-modal-content-prof {\n        min-width: 800px;\n    }\n    .search-results {\n        max-height: 40vh; /* Ajusta para caber melhor em telas menores */\n    }\n    \n}\n\n@media (max-width: 1024px) {\n    .my-modal-content-prof {\n        min-width: 600px;\n    }\n}\n\n@media (max-width: 768px) {\n    .my-modal-content-prof {\n        min-width: 400px;\n    }\n}\n@media (max-width: 600px) {\n    .my-modal-content-prof {\n        min-width: 300px;\n    }\n}\n\n@media (max-height: 667px) {\n    .my-modal-content-prof {\n        margin: 50px;\n    }\n}\n@media (max-height: 540px) {\n    .my-modal-content-prof {\n        max-height: 430px;\n        margin: 50px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
